import { EducationStepsEnum } from '@pages/hubs/Education/enum/education-steps-enum';

export const createEducationFormStepper = [
  EducationStepsEnum.preStepEducationType,
  EducationStepsEnum.generalBase,
  EducationStepsEnum.generalSecond,
  EducationStepsEnum.educationCoverPhoto,
  EducationStepsEnum.educationSkills,
  EducationStepsEnum.educationActivities,
  EducationStepsEnum.educationContact,
  EducationStepsEnum.educationShare,
  EducationStepsEnum.congratulations,
];

export const educationFormStepper = {
  [EducationStepsEnum.preStepEducationType]: {
    stepId: EducationStepsEnum.preStepEducationType,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 0,
  },
  [EducationStepsEnum.generalBase]: {
    stepId: EducationStepsEnum.generalBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 1,
  },
  [EducationStepsEnum.generalSecond]: {
    stepId: EducationStepsEnum.generalSecond,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 2,
  },
  [EducationStepsEnum.educationCoverPhoto]: {
    stepId: EducationStepsEnum.educationCoverPhoto,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 3,
  },
  [EducationStepsEnum.educationSkills]: {
    stepId: EducationStepsEnum.educationSkills,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 4,
  },
  [EducationStepsEnum.educationActivities]: {
    stepId: EducationStepsEnum.educationActivities,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 5,
  },
  [EducationStepsEnum.educationContact]: {
    stepId: EducationStepsEnum.educationContact,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 6,
  },
  [EducationStepsEnum.educationShare]: {
    stepId: EducationStepsEnum.educationShare,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 7,
  },

  [EducationStepsEnum.congratulations]: {
    stepId: EducationStepsEnum.congratulations,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 8,
  },
};
